import Helpers from "./helpers";
import SelectorFilter from "./selector-filter";

export default class FilterSticky {

	private stickyFilterContainerElement = SelectorFilter.excludeByClass(document.querySelectorAll('.js-filter-slideOut-sticky'), 'js-filter-slideOut-sticky-done')[0] as HTMLElement;
	private stickyClass = 'sticky';
	private ticking = false;
	private isActive = false;
	private onScrollFunctionRef = null;
	private readonly desktopBreakpoint = 980;

	constructor() {

		if (!this.stickyFilterContainerElement) return;

		this.setup();

	}

	setup() {
		
		this.checkIfScrollBeActive();

		window.addEventListener('resize', Helpers.debounce(()=> {
			this.checkIfScrollBeActive();
		}, 250));

		this.stickyFilterContainerElement.classList.add('js-filter-slideOut-sticky-done');
	}

	checkIfScrollBeActive() {

		const filterControls = this.stickyFilterContainerElement.querySelector('.js-filter-controls') as HTMLElement;
		const filterControlsContainer = document.querySelector('.js-filter-controls-container') as HTMLElement;

		if (window.matchMedia('(max-width: ' + this.desktopBreakpoint + 'px)').matches) {
			if (!this.isActive) {
				this.attachOnScroll(this.stickyFilterContainerElement, filterControls, filterControlsContainer);
				this.isActive = true;
			}
		} else {
			if (this.isActive) {
				if (this.onScrollFunctionRef) {
					window.removeEventListener('scroll', this.onScrollFunctionRef);
				}
				filterControls.classList.remove(this.stickyClass);
			}
			this.isActive = false;
		}

	}

	attachOnScroll(wrapper: HTMLElement, filterControls: HTMLElement, filterControlsContainer: HTMLElement) {

		this.onScrollFunctionRef = Helpers.debounce(() => {
			if (!this.ticking) {
				window.requestAnimationFrame(() => {
					if (!Helpers.isHidden(this.stickyFilterContainerElement)) {
						if (window.scrollY >= this.calculateWaypointPosition(wrapper) && window.scrollY < this.calculatingWaypointBottomPosition(filterControlsContainer)) {
							filterControls.classList.add(this.stickyClass);
						} else {
							filterControls.classList.remove(this.stickyClass);
						}
					}
					this.ticking = false;
				});
				this.ticking = true;
			}
		}, 20);

		window.addEventListener('scroll', this.onScrollFunctionRef);

	}

	calculateWaypointPosition(wrapper: HTMLElement) {
		let waypoint = this.offset(wrapper).top;
		if (!this.isCategoryPage()) waypoint -= 56;
		return waypoint;
	}

	calculatingWaypointBottomPosition(wrapper: HTMLElement) {
		if (!wrapper) {
			return document.documentElement.scrollHeight;
		}
		return this.offset(wrapper).top + wrapper.offsetHeight;
	}

	isCategoryPage() {
		return document.querySelectorAll('.c-section--category').length;
	}

	offset(el: HTMLElement) {
		var rect = el.getBoundingClientRect(),
			scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
			scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
	}
}
